import styled from 'styled-components'

import { PRIMARY_SECONDARY_COLOR,
  SECONDARY_NORMAL_COLOR,
  SECONDARY_LIGHT_COLOR,
  TEXT_GREY } from '@CSSVars/colors'

export const _Container = styled.div`
  margin-top: 2rem;

  h2 {
    font-size: 22px;
    font-weight: 300;
    line-height: 28px;
  }

  ul {
    a {
      transition: .3s all;
      cursor: pointer;
      color: ${SECONDARY_NORMAL_COLOR};
      &:hover {
        color: ${PRIMARY_SECONDARY_COLOR};
      }
    }
  }
`

export const _ListCount = styled.span`
  font-size: 20px;
  color: ${TEXT_GREY};
  position: relative;
  margin-left: 2px;
  &::before {
    content: "\\007C";
    padding-right: 5px;
    opacity: 0.5;
  }
`

export const _AreaList = styled.ul`
  padding: .5rem .75rem;
  margin-top: 0;
  background-color: rgba(255,255,255,.5);
  border-top: 2px solid white;
  column-count: 4;
  width: 100%;
  @media screen and (max-width: 63.9em) {
    column-count: 3;
  }
  @media screen and (max-width: 47.9em) {
    column-count: 2;
  }
  @media screen and (max-width: 33.9em) {
    column-count: 1;
  }
`

export const _Area = styled.li`
  width: 100%;
  padding: .5rem;
  display: inline-block;

  border-left: 3px solid ${PRIMARY_SECONDARY_COLOR};
  background-color: white;
  margin: .25rem 0;
  a {
    font-size: 16px;
    font-weight: 400;
  }
`

export const _SubAreaList = styled.ul`
  padding-left: 1rem;
  padding-top: .5rem;
  -webkit-padding-start: 20px;
`

export const _SubArea = styled.li`
  padding: .25rem 0;
  color: ${SECONDARY_LIGHT_COLOR};
  a {
    font-size: 14px;
    color: ${SECONDARY_LIGHT_COLOR};
    &:hover {
      color: ${PRIMARY_SECONDARY_COLOR};
      text-decoration: underline;
    }
  }
  &:last-child {
    padding-bottom: 0;
  }
`
